import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {StudyOverviewViewQuery} from 'studies/workspace/overview/__generated/StudyOverviewViewQuery';
import StudyAnalysisListView from 'studies/workspace/overview/StudyAnalysisListView';
import Pane, {PaneBorder} from 'ui-library/pane/Pane';

import MultiProcedureRunListingTable from './MultiProcedureRunListingTable';
import {ProcedureRunTab, StudyOverviewContext} from './MultiProcedureRunOverviewTabContents';
import ProcedureRunDetailsView from './ProcedureRunDetailsView';

type StudyNode = ExtractByTypename<StudyOverviewViewQuery['study'], 'StudyNode'>;

export default function MultiProcedureRunOverview({study}: {study: StudyNode}): JSX.Element {
  const {selectedProcedureRun, currentProcedureRunTab, setCurrentProcedureRunTab} =
    StudyOverviewContext.useContext();
  return (
    <div
      className={css(
        currentProcedureRunTab === ProcedureRunTab.OVERVIEW
          ? styles.studyBackgroundGray
          : styles.studyBackgroundWhite
      )}
    >
      {selectedProcedureRun.id == null ? (
        <div className={css(styles.runsContainer)}>
          <MultiProcedureRunListingTable studyId={study.id} />
          <div className={css(styles.analysisPaneWrapper)}>
            <Pane title="Analyses" paneBorder={PaneBorder.SOLID}>
              <div className={css(styles.analysisContainer)}>
                <StudyAnalysisListView studyId={study.id} showDate={false} />
              </div>
            </Pane>
          </div>
        </div>
      ) : (
        <ProcedureRunDetailsView
          studyType={study.studySchema.studyType}
          studyId={study.id}
          selectedProcedureRun={selectedProcedureRun}
          currentProcedureRunTab={currentProcedureRunTab}
          setCurrentProcedureRunTab={setCurrentProcedureRunTab}
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  studyBackgroundGray: {
    backgroundColor: Color.GRAY_100,
    height: '100%',
    maxHeight: '100%',
  },
  studyBackgroundWhite: {
    backgroundColor: Color.WHITE,
    height: '100%',
    maxHeight: '100%',
  },
  runsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '8px',
    height: '100%',
    maxHeight: '100%',
  },
  analysisPaneWrapper: {
    flex: '0 0 auto',
  },
  analysisContainer: {
    padding: '12px',
  },
});
